<div class="footer-top">
    <div class="container">
        <div class="row">
            <div class="col-md-3 footer-about wow fadeInUp">
                <img class="logo-footer" src="../../../../assets/images/logo_white.png" height="100px" alt="logo-footer">
                <p>
                    We deliver quality value added solutions and implementation whether in marketing and tech.
                </p>
                <p><a href="http://ganizaniconsultingservices.co.za/team/" target="_blank">Our Team</a></p>
            </div>
            <div class="col-md-4 offset-md-1 footer-contact wow fadeInDown">
                <h3>Contact</h3>
                <p><i class="fa fa-map-marker"></i> 09 Darnoc Avenue, Bordeaux, Randburg, 2194</p>
                <p><i class="fa fa-phone"></i> Phone: +27(0)62 263 1710</p>
                <p><i class="fa fa-envelope"></i><a href="info@ganizaniconsulting.com" target="_blank">info@ganizaniconsulting.com</a></p>
                <p><i class="fa fa-skype"></i> Skype: gani_online</p>
            </div>
            <div class="col-md-4 footer-links wow fadeInUp">
                <div class="row">
                    <div class="col">
                        <h3>Links</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <p><a class="scroll-link" target="_blank" href="http://ganizaniconsultingservices.co.za/">Home</a></p>
                        <!-- <p><a href="#">Features</a></p> -->
                        <p><a href="http://ganizaniconsultingservices.co.za/default/covid-19-report/" target="_blank">Covid-19 Report</a></p>
                        <p><a href="http://ganizaniconsultingservices.co.za/blog/" target="_blank">Blogs</a></p>
                    </div>
                    <div class="col-md-6">
                        <!-- <p><a href="#">Plans &amp; pricing</a></p> -->
                        <p><a href="#">Affiliates</a></p>
                        <p><a href="#">Terms</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="footer-bottom">
    <div class="container">
        <div class="row">
               <div class="col-md-6 footer-copyright">
                <!-- © Bootstrap Footer Template by <a href="#">CHERRY</a> -->
                © Ganizani Consulting Services
            </div>
               <div class="col-md-6 footer-social">
                <a href="https://facebook.com/ganizaniconsulting" target="_blank"><i class="fa fa-facebook-f"></i></a> 
                <a href="https://twitter.com/GanizaniConsult" target="_blank"><i class="fa fa-twitter"></i></a> 
                <a href="#"><i class="fa fa-google"></i></a> 
                <a href="https://www.instagram.com/ganizaniconsulting" target="_blank"><i class="fa fa-instagram"></i></a> 
                <a href="#"><i class="fa fa-pinterest"></i></a>
            </div>
           </div>
    </div>
</div>